export default "__VITE_ASSET__DUKo6SUh__"